"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dashboard = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
const react_native_1 = require("react-native");
const Dashboard_style_1 = require("./Dashboard.style");
const react_1 = __importStar(require("react"));
const User_service_1 = __importDefault(require("../../../services/User.service"));
const organisms_1 = require("../../../components/organisms");
const atome_1 = require("../../../components/atome");
const Breakpoints_1 = require("../../../helper/Breakpoints");
const hooks_1 = require("../../../store/hooks");
const reducers_1 = require("../../../store/reducers");
const AccountCreatedStep_component_1 = require("./AccountCreatedStep.component");
const UserInformationStep_component_1 = require("./UserInformationStep.component");
const ThirdCircleStep_component_1 = require("./ThirdCircleStep.component");
const FourthCircleStep_component_1 = require("./FourthCircleStep.component");
const FifthCircleStep_component_1 = require("./FifthCircleStep.component");
const FirstCurrentStep_component_1 = require("./FirstCurrentStep.component");
const SecondCurrentStep_component_1 = require("./SecondCurrentStep.component");
const ThirdCurrentStep_component_1 = require("./ThirdCurrentStep.component");
const FourthCurrentStep_component_1 = require("./FourthCurrentStep.component");
const NextStepFirstAppointment_component_1 = require("./NextStepFirstAppointment.component");
const NextStepFirstAppointmentTookPlace_component_1 = require("./NextStepFirstAppointmentTookPlace.component");
const NextStepLastStep_component_1 = require("./NextStepLastStep.component");
const PhoneSupport_component_1 = require("./PhoneSupport.component");
const PatientDeclined_1 = require("./PatientDeclined");
const StayTunedCurrentStep_component_1 = require("./StayTunedCurrentStep.component");
const date_fns_1 = require("date-fns");
// @ts-ignore
function Dashboard({ navigation, setToggleBarUp, setUserInfo }) {
    const appState = (0, react_1.useRef)(react_native_1.AppState.currentState);
    const auth = (0, hooks_1.useAppSelector)(reducers_1.selectAuth);
    const appData = (0, hooks_1.useAppSelector)(reducers_1.selectAppData);
    const userInformation = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const [scrollPosition, setScrollPosition] = (0, react_1.useState)(0);
    const [isToogleBarDisabled, setIsToogleBarDisabled] = (0, react_1.useState)(true);
    const [showFolgerezept, setShowFolgerezept] = (0, react_1.useState)(false);
    const [isTherapyModalVisible, setTherapyModalVisible] = (0, react_1.useState)(false);
    const aktuelRef = (0, react_1.useRef)(null);
    const isPatientDeclined = userInformation?.isPatientDeclined !== undefined &&
        userInformation?.isPatientDeclined === true;
    const getUserInfo = async () => await User_service_1.default.information();
    const getUserProgress = async () => await User_service_1.default.getProgress();
    const isNextDay = (date) => {
        return (0, date_fns_1.endOfDay)(new Date(date)) < (0, date_fns_1.startOfToday)();
    };
    const navigateTo = (screen, navigationParams) => {
        setToggleBarUp(false);
        setScrollPosition(1000);
        if (navigationParams) {
            navigation.navigate(screen, navigationParams);
            return;
        }
        navigation.navigate(screen);
    };
    const toComplete = () => {
        if (userInformation.progress.total === 0) {
            navigateTo('Splash');
        }
        else {
            navigateTo('CaseHistoryOverview');
        }
    };
    const scrollToAktuel = (x, y, width, height, web) => {
        if (aktuelRef.current !== null) {
            aktuelRef.current.scrollTo({
                x: web ? x + width : 0,
                y: web ? 0 : y + 2 * height,
                animated: true,
            });
            setTimeout(() => {
                setIsToogleBarDisabled(false);
            }, 500);
        }
    };
    (0, react_1.useEffect)(() => {
        const eventSub = react_native_1.AppState.addEventListener('change', next => {
            if (appState.current.match(/active/) &&
                next === 'background' &&
                !appData.isSelectingDocument) {
                dispatch((0, reducers_1.setAuth)({
                    isAuthenticated: false,
                    isTermsAgree: false,
                    isPrivacyPolicyAgree: false,
                    name: '',
                }));
                eventSub.remove();
            }
        });
        return () => eventSub.remove();
    }, [appData]);
    (0, react_1.useEffect)(() => {
        return navigation.addListener('focus', () => {
            setLoading(true);
            if (auth.isAuthenticated) {
                let promises = [getUserInfo(), getUserProgress()];
                Promise.all(promises)
                    .then(([info, progress]) => {
                    setLoading(false);
                    if (info?.message?.response?.status === 401 || progress.error) {
                        dispatch((0, reducers_1.setAuth)({ isAuthenticated: false }));
                        navigation.navigate('Login');
                        return;
                    }
                    const newUserInfo = { ...info.data, progress: progress.data };
                    setUserInfo(newUserInfo);
                    dispatch((0, reducers_1.setUserInformation)(newUserInfo));
                })
                    .catch(err => {
                    setLoading(false);
                    console.error(err);
                    //Maybe an alert here...
                    //Specify what should happen when the backend is unavailable for some reason...
                    //alert and redirect to login maybe??
                });
            }
        });
    }, [auth.isAuthenticated, navigation]);
    const monthNames = [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
    ];
    const checkingData = (0, react_1.useMemo)(() => userInformation?.progress.total === 100 &&
        userInformation?.progress.isDataConfirm, [userInformation]);
    function handleScroll(event) {
        setToggleBarUp(false);
        const currentPosition = event.nativeEvent.contentOffset.y;
        setScrollPosition(currentPosition);
    }
    const onTherapyModalOk = () => {
        setTherapyModalVisible(false);
        navigateTo('PatientenTracking', { redirectPage: 'OnlineAppointment' });
    };
    const onTherapyModalCancel = () => setTherapyModalVisible(false);
    const onlineAppointmentCheckAndRedirect = () => {
        const WEEK_SPAN = 8.64e7 * 7; // <= milliseconds in a day * 7 days  = milliseconds in a week
        let newestDateEpoch = new Date(0).getTime();
        userInformation?.lifeQuality.forEach(row => {
            let { queryDate } = row;
            let queryDateEpoch = new Date(queryDate).getTime();
            if (queryDateEpoch > newestDateEpoch) {
                newestDateEpoch = queryDateEpoch;
            }
        });
        let now = Date.now();
        let weekBeforeNow = now - WEEK_SPAN;
        if (newestDateEpoch <= weekBeforeNow) {
            setTherapyModalVisible(true);
            return;
        }
        navigation.navigate('OnlineAppointment');
    };
    const filteredPatientAppointments = userInformation?.appointment?.filter(a => String(a.carriedOut) !== '2' && String(a.carriedOut) !== '3');
    // Condition for Stay Tuned Step on Current Steps
    // is now 10 minutes after last Appointment's endDate &&
    // carriedOut is not set
    const showStayTunedCurrentStep = userInformation?.progress.isDataConfirm &&
        filteredPatientAppointments?.length > 0 &&
        filteredPatientAppointments[filteredPatientAppointments.length - 1]
            .carriedOut === undefined &&
        new Date() >
            (0, date_fns_1.addMinutes)(new Date(filteredPatientAppointments[filteredPatientAppointments.length - 1]?.endDate), 10);
    return (react_1.default.createElement(atome_1.ProtectedPage, { navigation: navigation },
        react_1.default.createElement(react_native_1.SafeAreaView, { style: [Dashboard_style_1.styles.whiteBackground] },
            react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
            (!userInformation || loading) && Breakpoints_1.isDesktop && react_1.default.createElement(atome_1.Loading, null),
            (!userInformation || loading) && Breakpoints_1.isMobile && (react_1.default.createElement(react_native_1.View, { style: [Dashboard_style_1.styles.greenDotsContainer] },
                react_1.default.createElement(atome_1.Loading, null))),
            userInformation && !loading && (react_1.default.createElement(react_native_1.ScrollView, { style: [Dashboard_style_1.styles.container], ref: aktuelRef, onScroll: handleScroll, scrollEventThrottle: 0 },
                react_1.default.createElement(react_native_1.View, null,
                    react_1.default.createElement(react_native_1.View, { style: [Dashboard_style_1.styles.timelineContainer] },
                        react_1.default.createElement(react_native_1.View, { style: Dashboard_style_1.styles.timeline }),
                        react_1.default.createElement(AccountCreatedStep_component_1.AccountCreatedStep, null),
                        ((userInformation?.progress.isDataConfirm &&
                            filteredPatientAppointments?.length > 0) ||
                            (userInformation?.isAlreadyCannabisPatient &&
                                filteredPatientAppointments?.length === 0) ||
                            userInformation.patientDataApproved) && (react_1.default.createElement(UserInformationStep_component_1.UserInformationStep, { navigateTo: navigateTo })),
                        !isPatientDeclined &&
                            userInformation?.progress.isDataConfirm &&
                            filteredPatientAppointments?.length > 0 &&
                            String(filteredPatientAppointments[0].carriedOut) === '1' && (react_1.default.createElement(ThirdCircleStep_component_1.ThirdCircleStep, null)),
                        !isPatientDeclined &&
                            userInformation?.progress.isDataConfirm &&
                            filteredPatientAppointments?.length > 1 &&
                            (isNextDay(filteredPatientAppointments[filteredPatientAppointments.length - 1].startDate) ||
                                String(filteredPatientAppointments[filteredPatientAppointments.length - 1].carriedOut) === '1') && (react_1.default.createElement(FourthCircleStep_component_1.FourthCircleStep, { userInformation: userInformation })),
                        !isPatientDeclined &&
                            userInformation?.progress.isDataConfirm &&
                            filteredPatientAppointments?.length > 2 &&
                            !isNextDay(filteredPatientAppointments[filteredPatientAppointments.length - 1].startDate) &&
                            isNextDay(filteredPatientAppointments[filteredPatientAppointments.length - 2].startDate) && react_1.default.createElement(FifthCircleStep_component_1.FifthCircleStep, { userInformation: userInformation }),
                        react_1.default.createElement(react_native_1.View, { style: [
                                Dashboard_style_1.styles.mobileCurrent,
                                isPatientDeclined ? { backgroundColor: '#FF991A' } : {},
                            ] },
                            !isPatientDeclined &&
                                (!userInformation?.progress.isDataConfirm ||
                                    filteredPatientAppointments?.length === 0 ||
                                    !filteredPatientAppointments) && (react_1.default.createElement(FirstCurrentStep_component_1.FirstCurrentStep, { userInformation: userInformation, checkingData: checkingData, navigateTo: navigateTo, toComplete: toComplete })),
                            !isPatientDeclined &&
                                userInformation?.progress.isDataConfirm &&
                                filteredPatientAppointments?.length > 0 &&
                                !isNextDay(filteredPatientAppointments[0].startDate) &&
                                String(filteredPatientAppointments[filteredPatientAppointments.length - 1].carriedOut) !== '1' &&
                                !showStayTunedCurrentStep &&
                                !userInformation?.isAlreadyCannabisPatient && (react_1.default.createElement(SecondCurrentStep_component_1.SecondCurrentStep, { userInformation: userInformation, monthNames: monthNames })),
                            !isPatientDeclined && showStayTunedCurrentStep && (react_1.default.createElement(StayTunedCurrentStep_component_1.StayTunedCurrentStep, { filteredPatientAppointments: filteredPatientAppointments, scrollToAktuel: scrollToAktuel })),
                            !isPatientDeclined &&
                                userInformation?.progress.isDataConfirm &&
                                !showStayTunedCurrentStep &&
                                filteredPatientAppointments?.length > 0 &&
                                (isNextDay(filteredPatientAppointments[filteredPatientAppointments?.length - 1].startDate) ||
                                    String(filteredPatientAppointments[filteredPatientAppointments.length - 1].carriedOut) === '1') && (react_1.default.createElement(ThirdCurrentStep_component_1.ThirdCurrentStep, { userInformation: userInformation, scrollToAktuel: scrollToAktuel, showFolgerezept: showFolgerezept, onlineAppointmentCheckAndRedirect: onlineAppointmentCheckAndRedirect, setShowFolgerezept: setShowFolgerezept, navigateTo: navigateTo })),
                            !isPatientDeclined &&
                                ((userInformation?.progress.isDataConfirm &&
                                    filteredPatientAppointments?.length > 1 &&
                                    !isNextDay(filteredPatientAppointments[filteredPatientAppointments?.length - 1].startDate) &&
                                    String(filteredPatientAppointments[filteredPatientAppointments.length - 1].carriedOut) !== '1') ||
                                    (userInformation?.progress.isDataConfirm &&
                                        filteredPatientAppointments?.length > 0 &&
                                        !isNextDay(filteredPatientAppointments[0].startDate) &&
                                        String(filteredPatientAppointments[filteredPatientAppointments.length - 1].carriedOut) !== '1' &&
                                        userInformation?.isAlreadyCannabisPatient)) && !showStayTunedCurrentStep && (react_1.default.createElement(FourthCurrentStep_component_1.FourthCurrentStep, { userInformation: userInformation, scrollToAktuel: scrollToAktuel })),
                            isPatientDeclined && (react_1.default.createElement(PatientDeclined_1.PatientDeclined, { scrollToAktuel: scrollToAktuel }))),
                        !isPatientDeclined &&
                            (filteredPatientAppointments?.length === 0 ||
                                !filteredPatientAppointments) && (react_1.default.createElement(NextStepFirstAppointment_component_1.NextStepFirstAppointment, { userInformation: userInformation })),
                        !(userInformation?.progress.isDataConfirm &&
                            filteredPatientAppointments?.length > 0 &&
                            (isNextDay(filteredPatientAppointments[0].startDate) ||
                                String(filteredPatientAppointments[0].carriedOut) === '1')) && react_1.default.createElement(NextStepFirstAppointmentTookPlace_component_1.NextStepFirstAppointmentTookPlace, null),
                        !isPatientDeclined && react_1.default.createElement(NextStepLastStep_component_1.NextStepLastStep, null)),
                    react_1.default.createElement(PhoneSupport_component_1.PhoneSupport, { navigateTo: navigateTo })))),
            react_1.default.createElement(organisms_1.TherapyMonitorModal, { visible: isTherapyModalVisible, onOk: onTherapyModalOk, onCancel: onTherapyModalCancel, purpose: "online-termin" }))));
}
exports.Dashboard = Dashboard;
